import { render, staticRenderFns } from "./LeadAssign.vue?vue&type=template&id=356653f3&scoped=true"
import script from "./LeadAssign.vue?vue&type=script&lang=js"
export * from "./LeadAssign.vue?vue&type=script&lang=js"
import style0 from "./LeadAssign.vue?vue&type=style&index=0&id=356653f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356653f3",
  null
  
)

export default component.exports